import { render, staticRenderFns } from "./MiraDonutWithLegend.vue?vue&type=template&id=653fc5cf&scoped=true&"
import script from "./MiraDonutWithLegend.vue?vue&type=script&lang=ts&"
export * from "./MiraDonutWithLegend.vue?vue&type=script&lang=ts&"
import style0 from "./MiraDonutWithLegend.vue?vue&type=style&index=0&id=653fc5cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653fc5cf",
  null
  
)

export default component.exports